import { DropdownItem } from 'reactstrap'
import { useNavigate } from 'react-router-dom'

export default function AdminMenuItem({ item }) {
  // console.log(`AdminMenuItem rendered: ${item.text}`)
  let navigate = useNavigate()

  function itemClicked(e) {
    console.log('AdminMenuItem: ', item)
    let url = ''
    if (item.search) {
      url = `/search/${item.search.id}`
    } else {
      switch (item.href) {
        case 'statistic.display_statistics':
          url = '/statistics'
          break
        case 'attribute.display_attributes':
          url = '/attributes'
          break
        case 'job.web_job_queue':
          url = '/jobs'
          break
        case 'userAttributes':
          url = '/userAttributes'
          break
        case 'poolStatistics':
          url = '/poolStatistics'
          break
        case 'logFileList':
          url = '/logFileList'
          break
        case 'openFilesList':
          url = '/openFilesList'
          break
        case 'manageSchemas':
          url = '/manageSchemas'
          break
        case 'exportUserObjects':
          url = '/exportUserObjects'
          break
        default:
          url = `/custom/${item.href}`
      }
    }
    navigate(url)
  }

  return <DropdownItem onClick={(e) => itemClicked(e)} data-cy={`admin-menu-item-${item.text.toLowerCase().replace(/ /g, '-')}`}>{item.text}</DropdownItem>
}
